var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7992 0H45.163L29.0795 18.6365L48 44H33.189L21.5802 28.6212L8.31291 44H0.938722L18.1382 24.0625L0 0H15.1864L25.6688 14.0567L37.7992 0ZM35.2125 39.5365H39.2907L12.9648 4.23077H8.58409L35.2125 39.5365Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.8f08bdd732340849a9207ff77afeff13.svg";
export { ForwardRef as ReactComponent };